@if (campaign) {
  @if (isShown(CampaignSections.DetailsSettings)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.campaignSettingsTitle" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.DetailsSettings)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>
          {{ "brand.campaign.summary.campaignName" | translate }} </strong
        >&nbsp;<span>{{ campaign.name }}</span>
      </div>
      <div>
        <strong> {{ "brand.campaign.summary.inviteLink" | translate }} </strong
        >&nbsp;<span>{{ campaign.getInvitationLink() }}</span>
      </div>
      <div>
        <strong> {{ "brand.campaign.summary.inviteCode" | translate }} </strong
        >&nbsp;<span>{{ campaign.invitationCode }}</span>
      </div>
      <a
        class="button-orange section-preview-button"
        (click)="previewCampaignBox()"
      >
        <mat-icon>visibility</mat-icon>
        {{ "brand.campaign.summary.seePreviewBox" | translate }}
      </a>
    </div>
  }
  @if (isShown(CampaignSections.DetailsInfo)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.campaignInfo" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.DetailsInfo)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <a
        class="button-orange section-preview-button"
        (click)="previewPartnerCampaign()"
      >
        <mat-icon>visibility</mat-icon>
        {{ "brand.campaign.summary.seePartnerPreview" | translate }}
      </a>
    </div>
  }
  @if (isShown(CampaignSections.DetailsInvitePage)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.invitePage" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.DetailsInvitePage)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong> {{ "brand.campaign.summary.inviteLink" | translate }} </strong
        >&nbsp;<span>{{ campaign.getInvitationLink() }}</span>
      </div>
      <a
        class="button-orange section-preview-button"
        href="{{ getInvitationPreviewLink() }}"
        target="__blank"
      >
        <mat-icon>visibility</mat-icon>
        {{ "brand.campaign.summary.seeInvitePage" | translate }}
      </a>
    </div>
  }
  @if (isShown(CampaignSections.Content)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.content" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.Content)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>
          {{ "brand.campaign.summary.facebookPostsTitle" | translate }} </strong
        >&nbsp;<span
          >{{ totalFacebookPosts }}
          {{ "brand.campaign.summary.facebookPosts" | translate }}</span
        >
      </div>
      <div>
        <strong>
          {{ "brand.campaign.summary.googleAdsTitle" | translate }} </strong
        >&nbsp;<span
          >{{ totalGoogleAds }}
          {{ "brand.campaign.summary.googleAds" | translate }}</span
        >
      </div>
      <div>
        <strong>
          {{
            "brand.campaign.summary.LinkedInPostsTitle" | translate
          }}: </strong
        >&nbsp;<span
          >{{ totalLinkedInPosts }}
          {{ "brand.campaign.summary.LinkedInPostsTitle" | translate }}</span
        >
      </div>
      <div>
        <strong>
          {{
            "brand.campaign.summary.onlineMarketingMaterial" | translate
          }} </strong
        >&nbsp;<span
          >{{ totalMarketingMaterial }}
          {{ "brand.campaign.summary.assetsAttached" | translate }}</span
        >
      </div>
    </div>
  }
  @if (isShown(CampaignSections.LandingPage)) {
    <div *ngIf="showLandingPage()" class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.landingPage" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.LandingPage)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>
          {{ "brand.campaign.summary.selectedOption" | translate }} </strong
        >&nbsp;
        <span *ngIf="campaign.landingPageLinkType === INDIVIDUAL_LANDING_PAGE">
          {{ "brand.campaign.landingPage.individualOption" | translate }}
        </span>
        <span *ngIf="campaign.landingPageLinkType === RETAILER_OWN_LINK">
          {{ "brand.campaign.landingPage.ownLinkOption" | translate }}
        </span>
        <span *ngIf="campaign.landingPageLinkType === ONE_SINGLE_LINK">
          {{ "brand.campaign.landingPage.singleLinkOption" | translate }}
        </span>
      </div>
    </div>
  }
  @if (isShown(CampaignSections.Ads)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.promoAdsSettings" | translate }}
        <a class="section-title-edit" (click)="goToRoute(CampaignSections.Ads)">
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.paymentType" | translate }}</strong
        >&nbsp;
        <span *ngIf="campaign.paymentType === PaymentType.Brand">
          {{ "shared.campaignPaymentType.brandFunded" | translate }}
        </span>
        <span *ngIf="campaign.paymentType === PaymentType.CoFunded">
          {{ "shared.campaignPaymentType.coFunded" | translate }}
          <span>
            {{
              "brand.campaign.summary.paymentTypePercentage"
                | translate
                  : {
                      brandPercentage: campaign.paymentTypePercentage,
                      partnerPercentage: 100 - campaign.paymentTypePercentage
                    }
            }}
          </span>
        </span>
        <span *ngIf="campaign.paymentType === PaymentType.Self">
          {{ "shared.campaignPaymentType.selfFunded" | translate }}
        </span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.datesType" | translate }}</strong
        >&nbsp;
        <span *ngIf="campaign.adDatesType === CAMPAIGN_SAME_DATES_TYPE">
          {{ "brand.campaign.promoAds.startEndTimeSame" | translate }}
          ({{ campaign.startDate | date: dateFormat() }}
          {{ "shared.toDate" | translate }}
          {{ campaign.endDate | date: dateFormat() }})
        </span>
        <span *ngIf="campaign.adDatesType !== CAMPAIGN_SAME_DATES_TYPE">
          {{ "brand.campaign.promoAds.startEndTimeSpecific" | translate }}
          ({{ campaign.fbCampaignStartDate | date: dateFormat() }}
          {{ "shared.toDate" | translate }}
          {{ campaign.fbCampaignEndDate | date: dateFormat() }})
        </span>
      </div>
      <div>
        <strong>
          {{ "brand.campaign.summary.targetSummary" | translate }}
        </strong>
        <span *ngIf="campaign.gender === Gender.Both">{{
          "brand.campaign.summary.genderBoth" | translate
        }}</span>
        <span *ngIf="campaign.gender === Gender.Male">{{
          "brand.campaign.summary.genderMalesOnly" | translate
        }}</span>
        <span *ngIf="campaign.gender === Gender.Female">{{
          "brand.campaign.summary.genderFemalesOnly" | translate
        }}</span>
        &nbsp;<span>{{
          "brand.campaign.summary.fromAgeAndRadius"
            | translate
              : {
                  minAge: campaign.minAge,
                  maxAge: campaign.maxAge,
                  radius: campaign.adTargetRadius
                }
        }}</span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.budgetSummary" | translate }}</strong
        >&nbsp;
        <span
          >{{ campaign.budgetPerAdPerPartner }}{{ campaign.currencySymbol }}
          {{ "brand.campaign.summary.adsSummary" | translate }}</span
        >
        <span>&nbsp;{{ campaign.maxAdsCampaignPartner }} Ads</span>
        <span>&nbsp;with a duration of {{ campaign.adDuration }} days</span>
      </div>

      <div class="section-subtitle">
        {{ "brand.campaign.summary.facebookPromoAds" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.AdsChannels)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.platforms" | translate }}</strong>
        <span *ngIf="campaign.publisherPlatformFacebook">
          &nbsp;{{ "shared.facebook" | translate }}
        </span>
        <span *ngIf="campaign.publisherPlatformInstagram">
          &nbsp;{{ "shared.instagram" | translate }}
        </span>
        <span *ngIf="campaign.publisherPlatformAudienceNetwork">
          &nbsp;{{ "shared.audienceNetwork" | translate }}
        </span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.actionType" | translate }}</strong
        >&nbsp;
        <span *ngIf="campaign.adActionType === AdActionType.Boost">
          {{ "brand.campaign.promoAds.actionTypeBoosted" | translate }}
        </span>
        <span *ngIf="campaign.adActionType === AdActionType.Link">
          {{ "brand.campaign.promoAds.actionTypeAdWithLink" | translate }}
        </span>
      </div>
      <div>
        <strong>{{
          "brand.campaign.summary.campaignObjective" | translate
        }}</strong
        >&nbsp;
        <span *ngIf="campaign.objective === ObjectiveType.Reach">
          {{ "brand.campaign.promoAds.optimizationTargetReach" | translate }}
        </span>
        <span *ngIf="campaign.objective === ObjectiveType.LinkClicks">
          {{
            "brand.campaign.promoAds.optimizationTargetLinkClicks" | translate
          }}
        </span>
        <span *ngIf="campaign.objective === ObjectiveType.Conversions">
          {{
            "brand.campaign.promoAds.optimizationTargetConversions" | translate
          }}
        </span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.CTAText" | translate }}</strong
        >&nbsp;
        <span>{{ getCTAText() }}</span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.targeting" | translate }}</strong
        >&nbsp;
        <span>{{ getFacebookTargetingNames() }}</span>
      </div>
      <div class="section-subtitle">
        {{ "brand.campaign.summary.googleAds" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.AdsChannels)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>{{
          "brand.campaign.summary.biddingStrategy" | translate
        }}</strong
        >&nbsp;
        <span>{{ getGoogleBiddingStrategy() }}</span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.bidAmount" | translate }}</strong
        >&nbsp;
        <span>{{ campaign.googleAdGroupBid }}</span>
      </div>
      <div>
        <strong>{{ "brand.campaign.summary.audience" | translate }}</strong
        >&nbsp;
        <span>{{ getGoogleTargeting() }}</span>
      </div>
    </div>
  }
  @if (isShown(CampaignSections.ContentCalendar)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.calendar" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.ContentCalendar)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div class="section-calendar">
        <div
          *ngFor="
            let calendarPost of brandCalendarPosts;
            trackBy: trackBrandCampaignCalendarPostByFn
          "
          class="section-calendar-post-wrap"
        >
          <div class="section-calendar-post">
            <div class="section-calendar-post-img">
              <div
                class="image"
                *ngIf="calendarPost.isRenderedAsImage"
                [ngStyle]="{
                  'background-image': 'url(' + calendarPost.image + ')'
                }"
              ></div>
              <!-- CAROUSEL -->
              <app-carousel
                *ngIf="calendarPost.mediaType === ContentType.Carousel"
                [isThumbnail]="true"
              >
                <div
                  carouselItem
                  *ngFor="
                    let item of calendarPost.carouselSlides;
                    trackBy: trackCalendarPostCarouselByFn
                  "
                  [image]="item.url"
                  [text]="item.title"
                  [videoUrl]="item.videoUrl"
                  [link]="null"
                ></div>
              </app-carousel>
              <!-- MULTI IMAGE -->
              <div
                *ngIf="
                  calendarPost.mediaType === LinkedInContentType.MultiImage
                "
                class="image"
                [ngStyle]="{
                  'background-image': 'url(' + calendarPost.images[0].url + ')'
                }"
              >
                <div class="extra-images">
                  <mat-icon class="extra-images__icon material-icons-outlined"
                    >photo_library</mat-icon
                  >
                  <span class="extra-images__number"
                    >+{{ calendarPost.images.length - 1 }}</span
                  >
                </div>
              </div>
              <!-- VIDEO -->
              <video
                style="width: 100%"
                *ngIf="calendarPost.mediaType === ContentType.Video"
                src="{{ getVideoUrl(calendarPost) }}"
                controls
              ></video>
              <!-- 360 IMAGE -->
              <app-panoramic-viewer
                *ngIf="
                  calendarPost.mediaType === ContentType.Image360 &&
                  calendarPost.image
                "
                [isThumbnail]="true"
                [imageUrl]="calendarPost.image"
              />
              <div class="section-calendar-post-img-icons">
                <img
                  *ngIf="calendarPost.isFacebookPost"
                  src="../../../../assets/images/icons/ic_facebookContent.svg"
                  alt="Facebook"
                />
                <img
                  *ngIf="calendarPost.postToInstagram"
                  src="../../../../assets/images/icons/ic_instagramContent.svg"
                  alt="Instagram"
                />
                <img
                  *ngIf="calendarPost.isGoogleAd"
                  src="../../../../assets/images/google-ad-logo.svg"
                  alt="GoogleAds"
                />
                <img
                  *ngIf="calendarPost.isLinkedInPost"
                  class="linkedin"
                  src="../../../../assets/images/icons/linkedin/ic_linkedin.svg"
                  alt="LinkedIn"
                />
              </div>
            </div>
            <div class="section-calendar-post-content">
              <div class="content-line">
                <strong>{{
                  "brand.campaign.summary.calendarPostDate" | translate
                }}</strong
                >&nbsp;
                {{ calendarPost.suggestedPublishDate | date: dateFormat() }}
              </div>
              <div class="content-line">
                <strong>{{
                  "brand.campaign.summary.calendarPostTime" | translate
                }}</strong
                >&nbsp;
                {{ calendarPost.suggestedPublishDate | date: "HH:mm" }}
              </div>
            </div>
            <div class="section-calendar-post-footer">
              <span
                *ngIf="calendarPost.isDarkPost && calendarPost.willBecomeAd"
              >
                {{
                  "brand.campaign.summary.darkPost"
                    | translate
                    | caseTransform: "RegularToCapitalized"
                }}
              </span>
              <span
                *ngIf="
                  !calendarPost.isDarkPost &&
                  (calendarPost.willBecomeAd || calendarPost.isGoogleAd)
                "
              >
                {{
                  "brand.campaign.summary.promoAd"
                    | translate
                    | caseTransform: "RegularToCapitalized"
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (isShown(CampaignSections.InvitePartners)) {
    <div class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.partners" | translate }}
        <a
          class="section-title-edit"
          (click)="goToRoute(CampaignSections.InvitePartners)"
        >
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>{{
          "brand.campaign.summary.partnersInvitedTitle" | translate
        }}</strong
        >&nbsp;
        <span>
          {{ totalPartnersInvited }}
          {{ "brand.campaign.summary.partnersInvited" | translate }},
          {{ totalPartnersNotInvited }}
          {{ "brand.campaign.summary.partnersNotInvited" | translate }}</span
        >
      </div>
    </div>
  }
  @if (isShown(CampaignSections.Pos)) {
    <div *ngIf="showPOS()" class="section">
      <div class="section-title">
        {{ "brand.campaign.summary.pos" | translate }}
        <a class="section-title-edit" (click)="goToRoute(CampaignSections.Pos)">
          <mat-icon>edit</mat-icon>
        </a>
      </div>
      <div>
        <strong>{{
          "brand.campaign.summary.interestedInPos" | translate
        }}</strong
        >&nbsp;
        <span *ngIf="campaign.includePos">{{ "shared.yes" | translate }}</span>
        <span *ngIf="!campaign.includePos">{{ "shared.no" | translate }}</span>
      </div>
    </div>
  }
}
